import { OobeState } from "./types";

export const OOBE_DEFAULT_STATE: OobeState = {};
